import { ReportSdk } from 'lib-klab-sdks';

const emptyPeriodRanking = (): ReportSdk.PeriodRankingResponse => ({
    today: [],
    yesterday: [],
    week: [],
});

const emptyActivityHistory = (): ReportSdk.ActivityHistoryResponse => ({
    content: [],
    page: { page: 0, size: 10, totalElements: 0, totalPages: 0 },
});

const mockPeriodActivity = (): ReportSdk.PeriodActivity => ({
    officeSeconds: 5332,
    officePercentage: 14.38,
    activeSeconds: 32400,
    activePercentage: 87.5,
    inactiveSeconds: 4680,
    inactivePercentage: 12.5,
    productiveSeconds: 26640,
    productivePercentage: 72,
    unproductiveSeconds: 2880,
    unproductivePercentage: 7.8,
    neutralSeconds: 2880,
    neutralPercentage: 7.8,
});

export const adminDashboardReportsSdkMock = {
    getEmployeeSummary: (): ReportSdk.EmployeeSummaryResponse => ({
        totalEmployees: 140,
        activeEmployees: 101,
        inactiveEmployees: 1,
        logOutEmployees: 14,
        absentEmployees: 8,
        suspendedEmployees: 24,
    }),

    getActivityBreakdown: (): ReportSdk.ActivityBreakdownResponse => ({
        today: mockPeriodActivity(),
        yesterday: mockPeriodActivity(),
        week: mockPeriodActivity(),
    }),

    getUsageWebsTop: (limit = 10): ReportSdk.PeriodRankingResponse => {
        const items = (labels: string[], percents: number[]): ReportSdk.RankingItem[] =>
            labels.slice(0, limit ?? 10).map((name, i) => ({
                id: i + 1,
                position: i + 1,
                name,
                timeSeconds: Math.floor(((percents[i] ?? 0) * 3600) / 100),
                percentage: percents[i],
            }));
        return {
            today: items(
                ['meet.google.com', 'youtube.com', 'notion.so', 'mail.google.com', 'x.com', 'app.empmonitor..'],
                [50, 20, 12, 9, 6, 3],
            ),
            yesterday: items(
                ['mail.google.com', 'meet.google.com', 'notion.so', 'youtube.com', 'drive.google.com', 'x.com'],
                [36.5, 26.2, 18.7, 9.9, 5.4, 2.1],
            ),
            week: items(
                ['meet.google.com', 'mail.google.com', 'notion.so', 'youtube.com', 'drive.google.com', 'docs.google.com', 'x.com', 'app.empmonitor..'],
                [33, 27, 16, 10.5, 7.2, 3.6, 1.8, 0.5],
            ),
        };
    },

    getUsageAppsTop: (limit = 10): ReportSdk.PeriodRankingResponse => {
        const items = (labels: string[], percents: number[]): ReportSdk.RankingItem[] =>
            labels.slice(0, limit ?? 10).map((name, i) => ({
                id: i + 1,
                position: i + 1,
                name,
                timeSeconds: Math.floor(((percents[i] ?? 0) * 3600) / 100),
                percentage: percents[i],
            }));
        return {
            today: items(
                ['Figma', 'Whatsapp', 'Google Chrome', 'Application frame host', 'Screeenpresso', 'Discord', 'Adobe Acrobat', 'Empmonitor'],
                [66.8, 12, 6.8, 4.3, 1.3, 0.3, 0.3, 0.3],
            ),
            yesterday: items(
                ['Google Chrome', 'Figma', 'Whatsapp', 'Visual Studio Code', 'Application frame host', 'Screeenpresso', 'Discord', 'Adobe Acrobat'],
                [38.2, 27.6, 14, 9.8, 6.1, 2.3, 1.2, 0.8],
            ),
            week: items(
                ['Google Chrome', 'Figma', 'Whatsapp', 'Visual Studio Code', 'Application frame host', 'Screeenpresso', 'Discord', 'Adobe Acrobat', 'Empmonitor'],
                [41, 32.5, 11.2, 7.6, 4.4, 1.3, 1.1, 0.6, 0.2],
            ),
        };
    },

    getUsageWebsHistory: () => emptyActivityHistory(),
    getUsageAppsHistory: () => emptyActivityHistory(),
    getProductivityDepartments: () => emptyPeriodRanking(),
    getProductivityLocations: () => emptyPeriodRanking(),
    getProductivityEmployeesTop: () => emptyPeriodRanking(),
    getProductivityEmployeesBottom: () => emptyPeriodRanking(),
    getProductivityEmployeesTopHistory: () => emptyActivityHistory(),
    getProductivityEmployeesBottomHistory: () => emptyActivityHistory(),
};
